module.exports = __webpack_public_path__ + "static/img/promotion_card_bg.0bbd3aa6.png";